import { useEffect, useState } from 'react'
import { getCurrentUser, supabase } from '../lib/supabaseClient'

export function useAuth() {
  const [user, setUser] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    getCurrentUser()
      .then((u) => {
        if (!mounted) return
        setUser(u)
        setProfile(u ? { role: u.role, dealer_status: u.dealer_status } : null)
        setLoading(false)
      })
      .catch(() => {
        if (mounted) setLoading(false)
      })
    return () => { mounted = false }
  }, [])

  const isDealer = profile?.role === 'dealer' && profile?.dealer_status === 'active'
  const isAdmin = profile?.role === 'admin' || user?.role === 'admin'

  const handleSignOut = async () => {
    await supabase.auth.signOut()
    setUser(null)
    setProfile(null)
    window.location.href = '/'
  }

  return { user, profile, isDealer, isAdmin, loading, signOut: handleSignOut }
}
